import { c as _c } from "react/compiler-runtime";
import type { SanityImageObject } from "@sanity/image-url";
import { Contributor, Links as SanityLinks } from "../../../../studio/sanity.types";
import { ResponsiveImage } from "../../../shared/responsiveimage";
import styles from "./TeamIntroduction.module.scss";
import { PortableText } from "@portabletext/react";
import { customComponentRenderers } from "../Paragraph/Citation";
import { Links, LinkType } from "../Links/Links";
import { NavLink } from "../../../shared/components/Navbar/Navbar";
export const TeamIntroduction: React.FC<{
  contributor: Contributor;
  links: SanityLinks;
  content: any[];
}> = t0 => {
  const $ = _c(45);
  const {
    contributor,
    content,
    links
  } = t0;
  if (!contributor) {
    return null;
  }
  if (!contributor.name) {
    return null;
  }
  let t1;
  if ($[0] !== contributor.name) {
    t1 = contributor.name.split(" ");
    $[0] = contributor.name;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const name = t1;
  const t2 = contributor.image as SanityImageObject;
  let t3;
  if ($[2] !== t2) {
    t3 = <div className={styles.innerImage}><ResponsiveImage image={t2} layout="cover" coverAspectRatio={0.875} sizes="(min-width: 1920px) 646px, (min-width: 1521px) calc(36vw - 40px), (min-width: 1181px) calc(36vw - 32px), calc(36vw - 12px)" /></div>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== name[0]) {
    t4 = <h4>{name[0]}</h4>;
    $[4] = name[0];
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = name[name.length - 1];
  let t6;
  if ($[6] !== t5) {
    t6 = <h4>{t5}</h4>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== contributor.email) {
    t7 = contributor.email && <a href={`mailto:${contributor.email}`}>{contributor.email}</a>;
    $[8] = contributor.email;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== contributor.phone) {
    t8 = contributor.phone && <a href={`tel:${contributor.phone}`}>{contributor.phone}</a>;
    $[10] = contributor.phone;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t7 || $[13] !== t8) {
    t9 = <div className={styles.contact}>{t7}{t8}</div>;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t4 || $[16] !== t6 || $[17] !== t9) {
    t10 = <div className={styles.mobileTitle}>{t4}{t6}{t9}</div>;
    $[15] = t4;
    $[16] = t6;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t3) {
    t11 = <div className={styles.image}>{t3}{t10}</div>;
    $[19] = t10;
    $[20] = t3;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== contributor.name) {
    t12 = <h4>{contributor.name}</h4>;
    $[22] = contributor.name;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== contributor.email) {
    t13 = contributor.email && <a href={`mailto:${contributor.email}`}>{contributor.email}</a>;
    $[24] = contributor.email;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== contributor.phone) {
    t14 = contributor.phone && <a href={`tel:${contributor.phone}`}>{contributor.phone}</a>;
    $[26] = contributor.phone;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t13 || $[29] !== t14) {
    t15 = <div className={styles.contact}>{t13}{t14}</div>;
    $[28] = t13;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== content) {
    t16 = <PortableText value={content} components={customComponentRenderers} />;
    $[31] = content;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t12 || $[34] !== t15 || $[35] !== t16) {
    t17 = <div className={styles.text}>{t12}{t15}{t16}</div>;
    $[33] = t12;
    $[34] = t15;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== links) {
    t18 = links && <Links links={links.links as (NavLink | LinkType)[]} />;
    $[37] = links;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== t17 || $[40] !== t18) {
    t19 = <div className={styles.content}>{t17}{t18}</div>;
    $[39] = t17;
    $[40] = t18;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== t11 || $[43] !== t19) {
    t20 = <div className={styles.container}>{t11}{t19}</div>;
    $[42] = t11;
    $[43] = t19;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  return t20;
};